var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBiker = function SvgBiker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "biker_svg__a",
    width: 20,
    height: 21,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .409h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#biker_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#57565C",
    d: "M12.756 4.945q-.607 0-1.033-.426a1.4 1.4 0 0 1-.425-1.033q0-.607.425-1.033a1.4 1.4 0 0 1 1.033-.425q.608 0 1.033.425.426.426.425 1.033 0 .608-.425 1.033a1.4 1.4 0 0 1-1.033.426M8.76 9.11l1.866 1.949v4.974h-1.25v-4.142L6.596 9.63a1.16 1.16 0 0 1-.348-.447 1.5 1.5 0 0 1-.096-.565q0-.33.107-.557a1.7 1.7 0 0 1 .337-.46l2.381-2.38q.23-.232.505-.338.274-.107.601-.107t.601.107.505.337l1.583 1.584q.554.554 1.293.906.738.351 1.643.392v1.266q-1.208-.04-2.175-.485a5.9 5.9 0 0 1-1.722-1.201L11 6.87zm-4.432 1.555q1.661 0 2.786 1.124t1.124 2.786-1.124 2.786q-1.125 1.125-2.786 1.124T1.54 17.362Q.417 16.237.417 14.576T1.54 11.79t2.786-1.124m0 6.827q1.203 0 2.06-.857a2.8 2.8 0 0 0 .856-2.06q0-1.204-.856-2.06a2.8 2.8 0 0 0-2.06-.857q-1.205 0-2.06.857a2.8 2.8 0 0 0-.857 2.06q0 1.203.857 2.06a2.8 2.8 0 0 0 2.06.857m11.346-6.827q1.662 0 2.786 1.124t1.124 2.786-1.124 2.786-2.786 1.124-2.786-1.124-1.124-2.786 1.124-2.786 2.786-1.124m0 6.827q1.203 0 2.06-.857a2.8 2.8 0 0 0 .857-2.06q0-1.204-.857-2.06a2.8 2.8 0 0 0-2.06-.857q-1.205 0-2.06.857a2.8 2.8 0 0 0-.857 2.06q0 1.203.857 2.06a2.8 2.8 0 0 0 2.06.857"
  }))));
};
export default SvgBiker;